const MAX_SAFE_CENTS = BigInt(Number.MAX_SAFE_INTEGER)
const DECIMAL_MONEY = /^(-?)(\d+)(?:\.(\d{1,2}))?$/

export function billingMoneyCents(value, { signed = true } = {}) {
  if (typeof value !== 'number' || !Number.isFinite(value)) return null
  if (!signed && value < 0) return null
  const match = DECIMAL_MONEY.exec(String(value))
  if (!match) return null
  const fraction = (match[3] || '').padEnd(2, '0')
  let cents = (BigInt(match[2]) * 100n) + BigInt(fraction || '0')
  if (match[1]) cents = -cents
  if (cents > MAX_SAFE_CENTS || cents < -MAX_SAFE_CENTS) return null
  const exactCents = Number(cents)
  const scaled = value * 100
  const lower = Math.floor(scaled)
  const consumerCents = scaled - lower < 0.5 ? lower : lower + 1
  const tolerance = Number.EPSILON * Math.max(1, Math.abs(scaled)) * 4
  if (
    consumerCents !== exactCents
    || Math.abs(scaled - consumerCents) > tolerance
  ) return null
  return exactCents
}
